import { useQuery } from 'react-query';
import { RemotePhsPaccRepo } from '@repository/phs/pacc/PhsPaccRepo';
import { PaccCompanyCurationResultVO } from '@domain/vo/phs/pacc/competence/PaccCompanyCurationResultVO';
import { PaccJobCurationResultVO } from '@domain/vo/phs/pacc/competence/PaccJobCurationResultVO';
import { PaccProfileResultVO } from '@domain/vo/phs/pacc/competence/PaccProfileResultVO';

const remotePhsPaccRepo = new RemotePhsPaccRepo();

export const phsPaccCompetenceKeys = ['phs', 'pacc', 'competence'];

export const usePHSPACCCompetenceCurationCompany = (sn: number) => {
  return useQuery(
    [...phsPaccCompetenceKeys, 'company', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCCompetenceCurationCompany(sn);
      return new PaccCompanyCurationResultVO(data);
    },
    {
      enabled: !!sn,
    },
  );
};

export const usePHSPACCCompetenceCurationJob = (sn: number) => {
  return useQuery(
    [...phsPaccCompetenceKeys, 'curation', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCCompetenceCurationJob(sn);
      return new PaccJobCurationResultVO(data);
    },
    {
      enabled: !!sn,
    },
  );
};

export const usePHSPACCCompetenceProfile = (sn: number) => {
  return useQuery(
    [...phsPaccCompetenceKeys, 'profile', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCCompetenceProfile(sn);
      return new PaccProfileResultVO(data);
    },
    {
      enabled: !!sn,
    },
  );
};
